import { Button, Descriptions, Dropdown, Popconfirm, Space } from "antd";
import { useNavigate, useParams, useRevalidator, useRouteLoaderData } from "react-router";
import { DeleteOutlined, EditOutlined, MoreOutlined, UserOutlined } from "@ant-design/icons";
import BackTitle from "../common/BackTitle";
import { date2locale } from "../common/common";
import axiosInstance, { api } from "../common/api";

export default function () {
  const navigate = useNavigate();
  const data = useRouteLoaderData("equipmentType");
  const { id } = useParams();
  const revalidator = useRevalidator();
  const fetch = () => revalidator.revalidate();

  const items = [
    {
      key: "name",
      label: "Nome",
      children: data.name,
    },
    {
      key: "requiredCourseType",
      label: "Corso di abilitazione richiesto",
      children: data.requiredCourseType?.title ?? "Nessuno",
    },
    {
      key: "firstInspectionDate",
      label: "Revisione ogni",
      children: data.firstInspectionDate && date2locale(data.firstInspectionDate),
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <BackTitle
        backEnabled={false}
        title="Dettagli categoria attrezzatura"
        secondary={`ID: ${id}`}
        extra={
          <Space size={4}>
            <Dropdown
              trigger={["click"]}
              menu={{
                items: [
                  {
                    key: "deleteEquipment",
                    label: (
                      <Popconfirm
                        title="Conferma rimozione"
                        onConfirm={() => api.equipmentType.delete(id).then(fetch)}
                        description="L'operazione è irreversibile. Procedendo, i dati verranno rimossi definitivamente."
                      >
                        Elimina
                      </Popconfirm>
                    ),
                    danger: true,
                    icon: <DeleteOutlined />,
                  },
                ].filter((x) => !!x),
              }}
            >
              <Button icon={<MoreOutlined />} />
            </Dropdown>
          </Space>
        }
      />
      <Descriptions
        layout="vertical"
        title={
          <>
            Informazioni generali
            <Button type="link" icon={<EditOutlined />} onClick={() => navigate("edit")} />
          </>
        }
        column={3}
        colon={false}
        items={items}
      />
    </div>
  );
}
